window.theme = window.theme || {};
theme.quickAdd = theme.quickAdd || {
  init: (quickAddModal) => {
    console.log(quickAddModal.querySelector(`.rtx-subscription`));
    theme.quickAdd.product.boxId = quickAddModal.querySelector(`.rtx-subscription`).dataset.label;
    theme.quickAdd.product.data = JSON.parse(quickAddModal.querySelector('.product-json').innerHTML);
    theme.quickAdd.product.data = theme.quickAdd.product.data.product;
    theme.quickAdd.product.variantId = JSON.parse(quickAddModal.querySelector('.product-current-variant').innerHTML);
    theme.quickAdd.product.variantId = theme.quickAdd.product.variantId.selectedOrFirstAvailableVariant;
    theme.quickAdd.product.variant = theme.quickAdd.product.data.variants.filter(v => v.id === theme.quickAdd.product.variantId)[0];
    theme.quickAdd.product.root = quickAddModal.querySelector(`[${theme.quickAdd.product.boxId}]`);
    theme.quickAdd.product.form = theme.quickAdd.product.root.closest('form[action="/cart/add"]')
    theme.quickAdd.product.subscriptionBox = quickAddModal.querySelector('[data-retextion-subscription-box]');
    theme.quickAdd.product.sellingPlanSelector = quickAddModal.querySelector('[name="selling_plan"]');
    theme.quickAdd.product.quantitySelector = quickAddModal.querySelector('[name="quantity"]');
    theme.quickAdd.product.purchaseType = quickAddModal.querySelectorAll('[name="purchaseType"]');
    theme.quickAdd.product.variantSelectors = quickAddModal.querySelectorAll('[name="id"]');
    theme.quickAdd.product.labelOneTime = quickAddModal.querySelector('[for="purchaseTypeOneTime"]');
    theme.quickAdd.product.labelSubscription = quickAddModal.querySelector('[for="purchaseTypeSubscription"]');
    theme.quickAdd.product.cachedSellingPlanId = quickAddModal.querySelector('[name="selling_plan"]') ? theme.quickAdd.product.root.querySelector('[name="selling_plan"]').value : undefined;
    theme.quickAdd.product.onetimeButton = quickAddModal.querySelector('.js-add-to-cart--onetime');
    theme.quickAdd.product.subscribeButton = quickAddModal.querySelector('.js-add-to-cart--subscribe');
    theme.quickAdd.product.media = {
      thumbnails: quickAddModal.querySelectorAll('li.product-thumbnail'),
      images: quickAddModal.querySelectorAll('div.product-image')
    };
    
    //document.querySelector('.quick-add-modal__content-info .product-video mux-player').play();

    theme.quickAdd.product.form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = theme.quickAdd.product.getFormData();
      console.log(formData);

      let id;
      let quantity;
      let selling_plan;

      formData.forEach(function (data) {
        if (data[0] == 'id') {
          id = data[1];
          console.log('id', id);
        }
        if (data[0] == 'quantity') {
          quantity = data[1];
          console.log('quantity', quantity);
        }
        if (data[0] == 'selling_plan') {
          selling_plan = data[1];
          console.log('seller_plan', selling_plan);
        }
      });

      if (id && quantity) {
        let requestBody = {
          'items': [{
            'id': id,
            'quantity': quantity,
            'selling_plan': selling_plan
          }],
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody)
        });
      }
    });

    theme.quickAdd.product.updateSubscriptionUI(theme.quickAdd.product.variant);

    theme.quickAdd.product.media.thumbnailSlider = new theme.vendor.Swiper('.product-thumbnails', {
      slidesPerView: 'auto',
      spaceBetween: 6,
      centeredSlides: false,
      loop: true,
      observer: true,
      cssMode: true,
      slideToClickedSlide: false,
    });

    theme.quickAdd.product.media.imageSlider = new theme.vendor.Swiper('.product-images', {
      speed: 400,
      slidesPerView: window.innerWidth >= 750 ? 1 : 2,
      centeredSlides: window.innerWidth >= 750 ? true : false,
      loop: true,
      observer: true,
      thumbs: {
        swiper: theme.quickAdd.product.media.thumbnailSlider
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      }
    });

    if (theme.quickAdd.product.variant.title !== "Default Title") {
      theme.quickAdd.product.setCurrentVariantMedia(theme.quickAdd.product.variant);
    }
    // document.querySelector('.product__accordion:last-child [id^="Details-"]').setAttribute('open', true);
    theme.quickAdd.product.UIEventListeners();
  },
  product: {
    removeEmptyOption: () => {
      const optEmpty = theme.quickAdd.product.sellingPlanSelector.querySelectorAll('[value=""]');
      optEmpty.forEach(e => e.remove());
    },
    addEmptyOption: () => {
      let optEmpty = theme.quickAdd.product.sellingPlanSelector.querySelector('[value=""]');
      if (optEmpty) return;
      optEmpty = document.createElement('option');
      optEmpty.value = '';
      optEmpty.textContent = 'select a frequency';
      optEmpty.setAttribute('selected', 'selected');
      theme.quickAdd.product.sellingPlanSelector.appendChild(optEmpty);
    },
    hideSubscriptionBox: () => {
      theme.quickAdd.product.cachedSellingPlanId = theme.quickAdd.product.sellingPlanSelector.value;
      theme.quickAdd.product.subscriptionBox.classList.remove('is-visible');
      theme.quickAdd.product.addEmptyOption();
      theme.quickAdd.product.sellingPlanSelector.value = '';
      theme.quickAdd.product.updateSellingPlan();
      if (theme.quickAdd.product.labelOneTime) theme.quickAdd.product.labelOneTime.classList.add('is-selected');
      if (theme.quickAdd.product.labelSubscription) theme.quickAdd.product.labelSubscription.classList.remove('is-selected');
    },
    resetSubscriptionBox: () => {
      document.querySelector('.rtx-subscription').classList.remove('select-frequency');
    },
    showSubscriptionBox: () => {
      theme.quickAdd.product.subscriptionBox.classList.add('is-visible');
      theme.quickAdd.product.sellingPlanSelector.value = theme.quickAdd.product.cachedSellingPlanId;
      theme.quickAdd.product.updateSellingPlan();
      if (theme.quickAdd.product.labelOneTime) theme.quickAdd.product.labelOneTime.classList.remove('is-selected');
      if (theme.quickAdd.product.labelSubscription) theme.quickAdd.product.labelSubscription.classList.add('is-selected');
    },
    isSubscriptionBoxVisible: () => {
      return theme.quickAdd?.subscriptionBox?.classList.contains('is-visible');
    },
    getSellingPlanId: () => {
      return parseInt(theme.quickAdd.product.sellingPlanSelector.value);
    },
    setSellingPlan: (sellingPlan) => {
      sellingPlan = sellingPlan && sellingPlan.id ? sellingPlan.id : sellingPlan;
      theme.quickAdd.product.sellingPlanSelector.value = sellingPlan.toString();
    },
    getFormData: () => {
      const formData = new FormData(theme.quickAdd.product.form);
      return Array.from(formData.entries());
    },
    submitFormAsync: (data) => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
    },
    updateSellingPlan: () => {
      const subscriptionLabels = theme.quickAdd.product.root.querySelectorAll('[data-rtx-subscription-price]');
      const oneTimeLabels = theme.quickAdd.product.root.querySelectorAll('[data-rtx-onetime-price]');
      const variant = theme.quickAdd.product.data.variants.find(v => v.id == theme.quickAdd.product.variantId);
      const sellingPlanId = theme.quickAdd.product.isSubscriptionBoxVisible() ? theme.quickAdd.product.getSellingPlanId() : undefined;
      const sellingPlanAllocation = sellingPlanId ? variant.selling_plan_allocations.find(spa => spa.selling_plan_id == sellingPlanId) : undefined;
      const firstSellingPlanAllocation = variant.selling_plan_allocations.find(spa => spa.selling_plan_id == theme.quickAdd.product.getSellingPlanId()) || variant.selling_plan_allocations.find(spa => spa);
      let strDiscount;
      if (firstSellingPlanAllocation && firstSellingPlanAllocation.price != variant.price) {
        let percentage = Math.round((1.0 - (firstSellingPlanAllocation.price / variant.price)) * 100);
        if (percentage != 0) {
          strDiscount = `${window.retextionApi.formatMoney(firstSellingPlanAllocation.price)}`.replace('.00', '');;
        } else {
          strDiscount = `${window.retextionApi.formatMoney(firstSellingPlanAllocation.price)}`.replace('.00', '');;
        }
      } else {
        strDiscount = null;
      }
      theme.quickAdd.product.resetSubscriptionBox();
      let strFullPrice = `${window.retextionApi.formatMoney(theme.quickAdd.product.variant.price)}`.replace('.00', '');

      if (strDiscount) {
        theme.quickAdd.product.enableSubscriptionUI();
        oneTimeLabels.forEach(fp => fp.textContent = strFullPrice);
        subscriptionLabels.forEach(dl => dl.textContent = strDiscount);
      } else {
        theme.quickAdd.product.disableSubscriptionUI();
        oneTimeLabels.forEach(fp => fp.textContent = strFullPrice);
        subscriptionLabels.forEach(dl => dl.textContent = strFullPrice);
      }

      if (theme.quickAdd.product.variant.available && theme.quickAdd.product.variant.inventory_quantity > 0) {
        theme.quickAdd.product.enableSubscriptionUI();
      } else {
        theme.quickAdd.product.disableSubscriptionUI();
      }

      window.retextionApi.sellingPlanPushHistory({
        sellingPlan: sellingPlanId
      });
      let x = theme.quickAdd.product.getFormData();

      //console.log('updateSellingPlan()', x[3][1], sellingPlanId);
    },
    setCurrentVariantLabel: (variant = theme.quickAdd.product.variant) => {
      if (document.querySelector('[data-product-option-1-value]') && variant.option1) {
        document.querySelector('[data-product-option-1-value]').innerHTML = variant.option1;
      }
      if (document.querySelector('[data-product-option-2-value]') && variant.option2) {
        document.querySelector('[data-product-option-2-value]').innerHTML = variant.option2;
      }
      if (document.querySelector('[data-product-option-3-value]') && variant.option3) {
        document.querySelector('[data-product-option-3-value]').innerHTML = variant.option3;
      }
    },
    updateVariantSelector: (variantId = theme.quickAdd.product.variantId) => {
      document.querySelector('[name="id"]').value = variantId;
    },
    updateStockStatus: (variant = theme.quickAdd.product.variant) => {
      document.querySelectorAll('.js-add-to-cart').forEach(function (button) {
        if (variant.available && variant.inventory_quantity > 0) {
          button.dataset.availability = 'available';
          button.disabled = false;
        }
        if (variant.available && variant.inventory_quantity <= 0 && variant.inventory_policy == 'continue') {
          button.dataset.availability = 'preorder';
          button.disabled = false;
        }
        if (!variant.available && variant.inventory_quantity <= 0 && variant.inventory_policy != 'continue') {
          button.dataset.availability = 'outofstock';
          button.disabled = true;
        }
        if (!theme.quickAdd.product.data.available) {
          button.dataset.availability = 'unavailable';
          button.disabled = true;
        }
      });
    },
    updateCurrentVariant: () => {
      let newVariant;
      for (let i = 0; i < theme.quickAdd.product.data.variants.length; i++) {
        let variant = theme.quickAdd.product.data.variants[i];
        if (document.querySelector('[data-product-option-1]')) {
          if (document.querySelector('[data-product-option-1] input:checked').value !== variant.option1) {
            continue;
          }
        }
        if (document.querySelector('[data-product-option-2]')) {
          if (document.querySelector('[data-product-option-2] input:checked').value !== variant.option2) {
            continue;
          }
        }
        if (document.querySelector('[data-product-option-3]')) {
          if (document.querySelector('[data-product-option-3] input:checked').value !== variant.option3) {
            continue;
          }
        }
        newVariant = variant;
      }
      if (newVariant) {
        theme.quickAdd.product.variant = newVariant;
        theme.quickAdd.product.variantId = newVariant.id;
        document.body.dispatchEvent(EVENT_VARIANT_CHANGE);
      }
    },
    disableSubscriptionUI: () => {
      document.querySelectorAll('.s-add-to-cart--subscribe').forEach(function (button) {
        button.dataset.availability = 'unavailable';
        button.disabled = true;
      });
      document.querySelectorAll('.product-purchase__benefits').forEach(function (benefits) {
        benefits.style.height = `${document.querySelector('.product-purchase__benefits').offsetHeight}px`;
        benefits.classList.add('benefits--hidden');
      });
    },
    enableSubscriptionUI: () => {
      document.querySelectorAll('.s-add-to-cart--subscribe').forEach(function (button) {
        button.dataset.availability = 'available';
        button.disabled = false;
      });
      document.querySelectorAll('.product-purchase__benefits').forEach(function (benefits) {
        //benefits.style.height = ``;
        benefits.classList.remove('benefits--hidden');
      });
    },
    setCurrentVariantMedia: function (variant) {
      theme.quickAdd.product.media.imageSlider.removeAllSlides();
      theme.quickAdd.product.media.images.forEach(function (slide, index) {
        let variantName = slide.dataset.imageAlt ? slide.dataset.imageAlt.split('#').slice(-1)[0] : slide.dataset.imageAlt;
        variantName = 'undefined' !== typeof slide.dataset.imageAlt && slide.dataset.imageAlt.includes('_') ? slide.dataset.imageAlt.split('_').slice(-1)[0] : variantName;
        if (slide.dataset.imageVariantId == variant.id || variantName === theme.quickAdd.product.variant.title) {
          let slideHTML = theme.methods.nodeToString(theme.quickAdd.product.media.images[index]);
          slideHTML = slideHTML.replace('\"', '"');
          theme.quickAdd.product.media.imageSlider.appendSlide(slideHTML);
        }
      });
      theme.quickAdd.product.media.imageSlider.slideTo(0, 500);

      theme.quickAdd.product.media.thumbnailSlider.removeAllSlides();

      theme.quickAdd.product.media.thumbnails.forEach(function (slide, index) {
        let variantName = slide.dataset.imageAlt ? slide.dataset.imageAlt.split('#').slice(-1)[0] : slide.dataset.imageAlt;
        variantName = 'undefined' !== typeof slide.dataset.imageAlt && slide.dataset.imageAlt.includes('_') ? slide.dataset.imageAlt.split('_').slice(-1)[0] : variantName;
        if (slide.dataset.imageVariantId == variant.id || variantName === theme.quickAdd.product.variant.title) {
          let slideHTML = theme.methods.nodeToString(theme.quickAdd.product.media.thumbnails[index]);
          slideHTML = slideHTML.replace('\"', '"');
          theme.quickAdd.product.media.thumbnailSlider.appendSlide(slideHTML);
        }
      });
      theme.quickAdd.product.media.thumbnailSlider.slideTo(0, 500);
    },
    updateSubscriptionUI: (variant = theme.quickAdd.product.variant, scope = document) => {
      let subscriptionButton = scope.querySelector('.subscription-button button');
      let subscriptionBenefits = scope.querySelector('.product-purchase__benefits');
      let discountBadge = scope.querySelector('.discount-badge');
      if (variant.selling_plan_allocations.length > 0) {
        if (subscriptionButton) {
          subscriptionButton.disabled = false;
        }
        if (subscriptionBenefits) {
          subscriptionBenefits.classList.remove('disabled');
        }
        if (discountBadge) {
          discountBadge.classList.remove('disabled');
        }
      } else {
        if (subscriptionButton) {
          subscriptionButton.disabled = true;
        }
        if (subscriptionBenefits) {
          subscriptionBenefits.classList.add('disabled');
        }
        if (discountBadge) {
          discountBadge.classList.add('disabled');
        }
      }
    },
    updateBadgeUI: (variant = theme.product.variant, scope = document) => {
      let variantBadges = scope.querySelectorAll('.variant-badge');
      if (variantBadges) {
        variantBadges.forEach(badge => {
          const badgeID = parseInt(badge.dataset.id);
          if (variant.id === badgeID) {
            badge.classList.remove('disabled');
          } else {
            badge.classList.add('disabled');
          }
        });
      }
    },
    UIEventListeners: () => {
      theme.quickAdd.product.purchaseType.forEach(el => {
        el.addEventListener('change', e => {
          if (el.value === 'purchaseTypeSubscription') {
            theme.quickAdd.product.showSubscriptionBox();
          } else {
            theme.quickAdd.product.hideSubscriptionBox();
          }
        });
      });
      theme.quickAdd.product.variantSelectors.forEach(vs => {
        vs.addEventListener('change', e => {
          let newOptions = '';
          theme.quickAdd.product.variantId = e.target.value;
          const variant = theme.quickAdd.product.data.variants.find(v => v.id == theme.quickAdd.product.variantId);

          // Determine the selected option
          let selectedPlanId = theme.quickAdd.product.getSellingPlanId();
          if (!variant.selling_plan_allocations.some(spa => {
            return spa.selling_plan_id == selectedPlanId;
          })) {
            if (variant.selling_plan_allocations.length) {
              selectedPlanId = variant.selling_plan_allocations[0].selling_plan_id;
            } else {
              selectedPlanId = '';
            }
          }
          // Generate new options
          variant.selling_plan_allocations.forEach((spa, i) => {
            const sellingGroup = boxProduct.selling_plan_groups.find(spg => spg.id === spa.selling_plan_group_id);
            const sellingPlan = sellingGroup.selling_plans.find(sp => sp.id === spa.selling_plan_id);
            if (sellingGroup.app_id != RETEXTION_APP_ID) return;
            const opt = document.createElement('option');
            if (sellingPlan.id == selectedPlanId) {
              opt.setAttribute('selected', 'selected');
            }
            opt.value = sellingPlan.id;
            opt.textContent = sellingPlan.name;
            newOptions += opt.outerHTML;
          });

          // Update select
          elementSellingPlan.innerHTML = newOptions;
          theme.quickAdd.product.updateSellingPlan();
        });
      });

      document.body.addEventListener('variantChange', e => {
        theme.quickAdd.product.setCurrentVariantLabel(theme.quickAdd.product.variant);
        theme.quickAdd.product.updateSellingPlan();
        theme.quickAdd.product.updateVariantSelector(theme.quickAdd.product.variant.id);
        theme.quickAdd.product.updateStockStatus(theme.quickAdd.product.variant);
        theme.quickAdd.product.updateSubscriptionUI(theme.quickAdd.product.variant);
        theme.quickAdd.product.updateBadgeUI(theme.quickAdd.product.variant);
        if (theme.quickAdd.product.variant.title !== "Default Title") {
          theme.quickAdd.product.setCurrentVariantMedia(theme.quickAdd.product.variant);
        }
      });

      document.body.addEventListener('click', e => {
        if (!e.target.matches('#purchaseTypeOneTime')) return;
        // console.log('Onetime Clicked', e);
        // document.querySelector('.rtx-subscription').classList.remove('select-frequency');
        // theme.quickAdd.product.onetimeButton.click();
      });

      document.body.addEventListener('click', e => {
        if (!e.target.matches('#purchaseTypeSubscription')) return;
        const sellingPlanCount = document.querySelectorAll('.rtx-subscription-dropdown option').length;
        theme.quickAdd.product.updateSellingPlan();
        if (sellingPlanCount !== 2) {
          document.querySelector('.rtx-subscription-dropdown').value = ''
          setTimeout(() => {
            document.querySelector('.rtx-subscription').classList.add('select-frequency');
          }, 100);
        } else {
          document.querySelector('.rtx-subscription-dropdown option:last-child').selected = true;
          // theme.quickAdd.product.subscribeButton.click();
        }
      });

      document.body.addEventListener('click', e => {
        if (!e.target.matches('.product-options .radio input')) return;
        theme.quickAdd.product.updateCurrentVariant();
      });

      document.body.addEventListener('change', e => {
        if (!e.target.matches('.rtx-subscription-dropdown')) return;
        theme.quickAdd.product.subscribeButton.click();
        //document.querySelector('.product-purchase').classList.remove('select-frequency');
      });
    }
  }
};
